import React, { useMemo } from "react";
import PathPickSizeStockModal from "@/features/pathpick/components/product/PathPickSizeStockModal";
import { LineSheetProduct } from "@/features/line-sheet-sets/line-sheet-set.types";
import {
  LineSheetProductMarketPrice,
  LineSheetSetMarketPricing,
} from "@/features/order-sheet-sets/hooks/use-line-sheet-set-market-prices";
import {
  calcEstimatedSupplyKrw,
  toMarketProduct,
} from "@/features/order-sheet-sets/utils/order-sheet-market-product";

interface Props {
  product: LineSheetProduct | null;
  marketPrice: LineSheetProductMarketPrice | null;
  // 예상 매입가 계산 재료(환율·정액 수수료). 공급가는 product 의 현재 값을 쓴다.
  pricing: LineSheetSetMarketPricing | undefined;
  onClose: () => void;
}

/**
 * 오더시트에서 여는 사이즈별 크림·포이즌 시세 — 패스픽의 사이즈별 시세 모달을 그대로 쓴다.
 * 오더시트에는 패스픽의 "비교 감추기" 설정이 없으므로 항상 비교를 보여준다.
 */
export default function OrderSheetMarketSizeModal({
  product,
  marketPrice,
  pricing,
  onClose,
}: Props) {
  const item = useMemo(
    () =>
      product && marketPrice
        ? toMarketProduct(
            product,
            marketPrice,
            calcEstimatedSupplyKrw(product.supplyPrice, marketPrice, pricing)
          )
        : null,
    [product, marketPrice, pricing]
  );
  if (!item) {
    return null;
  }
  return (
    <PathPickSizeStockModal
      isOpen={true}
      onClose={onClose}
      item={item}
      viewOverride={{ showComparison: true, comparisonLayout: "side" }}
    />
  );
}
